<form [formGroup]="eventItemForm" (ngSubmit)="saveForm()" #ngForm="ngForm">
  <div class="row g-3">
    <div class="form-group col-md-12">
      <label for="title" class="required"
        >Event Title (Max 45 characters)</label
      >
      <input
        type="text"
        class="form-control mt-2"
        formControlName="title"
        placeholder=""
        maxlength="45"
        [ngClass]="{ invalid: title.invalid && ngForm.submitted }"
      />
    </div>
    <div class="form-group col-md-6">
      <label for="startDate" class="required">Start Date</label>
      <div class="input-group">
        <input
          class="form-control"
          placeholder="yyyy-mm-dd"
          name="startDate"
          formControlName="startDate"
          ngbDatepicker
          #start="ngbDatepicker"
          [minDate]="minDate"
          [ngClass]="{ invalid: startDate.invalid && ngForm.submitted }"
        />
        <button
          class="btn btn-outline-secondary"
          (click)="start.toggle()"
          type="button"
        >
          <fa-icon [icon]="faCalendar"></fa-icon>
        </button>
      </div>
      <!-- <ngb-timepicker formControlName="startTime" [meridian]="true"
        [ngClass]="{ invalid: startTime.invalid && ngForm.submitted }"></ngb-timepicker>
      <span class="text-danger" *ngIf="ngForm.submitted && startTime.invalid"><strong>* Start Time is
          required.</strong></span> -->
    </div>
    <div class="form-group col-md-6">
      <label for="endDate"
        >End Date (Leave blank if event is only one day)</label
      >
      <div class="input-group">
        <input
          class="form-control"
          placeholder=""
          name="endDate"
          formControlName="endDate"
          ngbDatepicker
          #end="ngbDatepicker"
          [minDate]="minDate"
        />
        <button
          class="btn btn-outline-secondary"
          (click)="end.toggle()"
          type="button"
        >
          <fa-icon [icon]="faCalendar"></fa-icon>
        </button>
      </div>
      <!-- <ngb-timepicker formControlName="endTime" [meridian]="true"></ngb-timepicker> -->
    </div>
    <div class="form-group col-md-6">
      <label for="registrationLinkText">Registration link text</label>
      <input
        type="text"
        class="form-control mt-2"
        formControlName="registrationLinkText"
        placeholder=""
        maxlength="25"
        [ngClass]="{
          invalid: registrationLinkText.invalid && ngForm.submitted
        }"
      />
    </div>
    <div class="form-group col-md-6">
      <label for="registrationUrl" class="required"
        >Registration link (URL, include http://)</label
      >
      <input
        type="text"
        class="form-control mt-2"
        formControlName="registrationUrl"
        placeholder=""
        maxlength="250"
        [ngClass]="{ invalid: registrationUrl.invalid && ngForm.submitted }"
      />
    </div>

    <div class="form-group col-md-6">
      <label for="location" class="required">Location</label>
      <input
        type="text"
        class="form-control mt-2"
        formControlName="location"
        placeholder=""
        maxlength="250"
        [ngClass]="{ invalid: location.invalid && ngForm.submitted }"
      />
    </div>
    <!-- <div class="form-group col-md-6">
      <label for="imageUrl" class="required">Flyer URL</label>
      <input type="text" class="form-control mt-2" formControlName="imageUrl" placeholder="" maxlength="250"
        [ngClass]="{ invalid: imageUrl.invalid && ngForm.submitted }" />
    </div> -->
    <div class="col-md-6 formspace">
      <label for="imageUrl" class="form-label required"
        >Upload Flyer Image</label
      >
      <div class="row">
        <div class="col-md-6 mt-1">
          <input
            type="text"
            formControlName="imageFileName"
            class="form-control"
            id="imageFileName"
            placeholder="Select a .jpg or a .png file"
            [ngClass]="{ invalid: imageFileName.invalid && ngForm.submitted }"
          />
        </div>
        <div class="col-md-6">
          <div class="file-btn-wrapper">
            <button type="button" class="btn btn-outline-primary">
              {{ isEdit ? "Change.. " : "Browse.." }}
            </button>
            <input
              type="file"
              name="file"
              (change)="fileChange($event)"
              accept="image/*"
              id="logoUpload"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="center mt-5">
      <button
        type="submit"
        class="btn btn-primary mb-3"
        [disabled]="isProcessing"
        aria-label="save"
      >
        Save
      </button>
    </div>
  </div>
</form>
